<template>
  <div class="teaminform">
    <headerview :cur="2"></headerview>

    <div class="content">

      <div class="moddlecon w13">
        <div class="tipcon">
          <tipconNav v-show="type == 1||type == 4" :title="'重要资讯'" :name="[{label:'重要资讯',url:''}]" :imgtype="'2'" width="2"></tipconNav>
          <tipconNav v-show="type == 2||type == 5" :title="'最新通知'" :name="[{label:'最新通知',url:''}]" :imgtype="'2'" width="2"></tipconNav>
          <tipconNav v-show="type == 3||type == 6" :title="'各地动态'" :name="[{label:'各地动态',url:''}]" :imgtype="'2'" width="2"></tipconNav>
        </div>

        <div class="listcon_public min-h">
          <div class="signle" v-for="(item,index) in list" :key="index" @click="seedetail(item)">
            <div class="title line1" :title="item.title">{{ item.title||'' }}</div>
            <div class="time">{{ item.pubTime ? item.pubTime.split(' ')[0] : '' }}</div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="" v-if='showFoot'>
          <div is='footPage' class="zhini-pagination"
               :currentPage="pageNo"
               :totalPage="total"
               @pageNum="pageNum" :pagesize='pageSize'></div>
        </div>

      </div>

    </div>

    <footview></footview>

  </div>

</template>

<script>

import footPage from '../../../components/footpage/footpage.vue'

export default {
  components: {
    footPage,
  },
  data: function () {
    return {
      list: [],
      infoType: "2",
      type: "1",
      pageNo: 1,
      total: 5,
      pageSize: 8,
      showFoot:true,
      t:0
    };
  },

  watch: {
    '$route'(to, from) {   //监听路由是否变化
      console.log(333,to, from)
      if (to.query.type != from.query.type) {
        this.type = to.query.type
        this.pageNo = 1
        this.showFoot=false;
        this.$nextTick(()=>{ 
          this.showFoot=true
        });
        console.log(333,this.pageNo)
        this.getlist()  //重新加载数据
      }
    }
  },

  mounted() {
    this.$onScrollT()
    this.pageNo = 1
    if (this.$route.query) {
      this.type = this.$route.query.type;
      this.pageNo = 1
      this.getlist()
    }
  },

  methods: {
    getlist() {
      if (this.type == "1") {
        this.infoType = "2"
      } else if (this.type == "2") {
        this.infoType = "1"
      } else if (this.type == "3") {
        this.infoType = "6"
      }
      this.$get(`web/info/list?pageSize=8&pageNo=${this.pageNo}&infoType=${this.infoType}`).then(res => {
        if (res.success) {
          this.total = res.result.total
          this.list = res.result.records
        }
      })
    },
    format() { //对事件原型进行拓展
        /**
         *对Date的扩展，将 Date 转化为指定格式的String
         *月(M)、日(d)、小时(h)、分(m)、秒(s)、季度(q) 可以用 1-2 个占位符，
         *年(y)可以用 1-4 个占位符，毫秒(S)只能用 1 个占位符(是 1-3 位的数字)
         *例子：
         *(new Date()).Format("yyyy-MM-dd hh:mm:ss.S") ==> 2006-07-02 08:09:04.423
         *(new Date()).Format("yyyy-M-d h:m:s.S")      ==> 2006-7-2 8:9:4.18
         */
        Date.prototype.format = function(fmt) {
            var o = {
                "M+": this.getMonth() + 1, //月份
                "d+": this.getDate(), //日
                "h+": this.getHours(), //小时
                "m+": this.getMinutes(), //分
                "s+": this.getSeconds(), //秒
                "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                "S": this.getMilliseconds() //毫秒
            };
            if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
            for (var k in o)
                if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
            return fmt;
        }

    },
    seedetail(item) {
      this.format()
      var newTime=new Date()
      this.t=newTime.format("yyyy-MM-dd hh:mm:ss")
      if (this.type ==1||this.type ==4) {
        this.$router.push({path: '/textdetail?id=' + item.id + '&type=4&t='+this.t});
      } else if (this.type == 2||this.type ==5) {
        this.$router.push({path: '/textdetail?id=' + item.id + '&type=5&t='+this.t});
      } else if (this.type ==3||this.type ==6) {
        this.$router.push({path: '/textdetail?id=' + item.id + '&type=6&t='+this.t});
      }

    },

    pageNum(e) {
      this.pageNo = e;
      this.$onScrollT()
      this.getlist()
    },


  },


};
</script>

<style scoped="scoped" lang="scss">

.teaminform {}
.content {
  display: flex;
  justify-content: center;
  .moddlecon {
    background-color: #FFFFFF;
    padding: 20px 50px 0px 50px;
    box-sizing: border-box;
  }
}
.listcon_public .signle .title{
  width: calc(100% - 150px)!important;
}
</style>
